import './SignUp.css';
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { isMobile } from 'react-device-detect';
import Footer2 from './Footer2';
import subscribeUser from '../Mailchimp/MailchimpConnection';
import logo from "./images/welleo_logo_transp.png";
import Footer3 from './Footer3';

const OpenPDF = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const pdfUrl = '/Privacy Policy.pdf';

    if (isMobile) {
        window.location.href = pdfUrl;
    } else {
        window.open(pdfUrl, '_blank');
    }
};

const SignUp = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [device, setDevice] = useState("");
    const handleDeviceChange = (e) => {
        setDevice(e.target.value);
    };
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return 'Invalid email';
        }

        const domainRegex = /\.(com|se|ru|net|org|info|biz|gov|edu|mil|int|name|pro|aero|coop|museum|xyz|top|site|online|tech|store|art|blog|club|design|space|wiki|shop|us|uk|ca|de|fr|es|it|nl|au|ch|jp|cn|in)$/i;
        if (!domainRegex.test(email)) {
            return 'Invalid email';
        }

        return '';
    };

    const handleChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);

        const validationError = validateEmail(newEmail);
        setMessage(validationError);
        setMessageType(validationError ? 'error' : '');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setMessageType('');
        setIsLoading(true);

        if (!device) {
            setMessage("Please select your device (Android or iOS).");
            setMessageType("error");
            setIsLoading(false);
            return;
        }

        const validationError = validateEmail(email);
        if (validationError) {
            setMessage(validationError);
            setMessageType('error');
            setIsLoading(false);
            return;
        }

        try {
            await subscribeUser(email, isChecked2, isChecked, device); // Pass device to Mailchimp call
            setMessage('Email submitted successfully!');
            setMessageType('success');
        } catch (error) {
            setMessage(`Failed to submit email: ${error.message}`);
            setMessageType('error');
        } finally {
            setIsLoading(false);
        }
    };


    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleCheckboxChange2 = (event) => {
        setIsChecked2(event.target.checked);
    };

    return (
<div className="HomePage3">
    <Helmet>
        <link rel="canonical" href="https://staflyapp.com/SignUp" />
        <meta name="robots" content="noindex" />
        <title>Sign Up to Stafly Today</title>
        <meta name="description" content="Sign up today to be notified when Stafly is available"/>
        <meta property="og:image" content={logo} />
        <meta property="og:url" content="https://staflyapp.com" />
        <meta name="twitter:image" content={logo} />
    </Helmet>

    <div className="overlay"></div>

    <div className="SignUpBody">
        <div className="Content1">
            <h1 className="H12">CONTROL YOUR HEALTH AND PERFORMANCE</h1>
            <h2 className="BolderP">We will notify you when Stafly is available.</h2>

            <form onSubmit={handleSubmit} className="InputButton">
    <input
        type="email"
        placeholder="Enter Email"
        className="Input-Body2"
        value={email}
        onChange={handleChange}
        required
    />

    <div className={`DeviceSelector ${!device && messageType === "error" ? "error" : ""}`}>
        <span className="DeviceLabel">Select a device</span>

        <div className="DeviceOptions">
            <div
                className={`DeviceOption ${device === "android" ? "selected" : ""}`}
                onClick={() => setDevice("android")}
            >
                Android
            </div>

            <div
                className={`DeviceOption ${device === "ios" ? "selected" : ""}`}
                onClick={() => setDevice("ios")}
            >
                iOS
            </div>
        </div>
    </div>

    <div className="CheckBoxDiv">
        <input
            type="checkbox"
            id="checkbox"
            name="newsletter"
            value="subscribe"
            checked={isChecked}
            onChange={handleCheckboxChange}
        />
        <label className="checkboxText" htmlFor="checkbox">
            Send me regular health and fitness updates
        </label>
    </div>

    <div className="CheckBoxDiv">
        <label className="checkboxText" htmlFor="checkbox2">
            By signing up, you confirm that, you are 13 years old or older, have read and agree with the 
            <span className="colored-text" onClick={() => OpenPDF()}> Privacy Policy</span>
        </label>
    </div>

    <button 
        type="submit" 
        className="SignUpButton buttonSign" 
        disabled={isLoading} // <-- only disable while loading
    >
        {isLoading ? 'Processing...' : 'SIGN UP'}
    </button>

    <div className="ResponseMessage">
        {message && <p className={`message ${messageType}`}>{message}</p>}
    </div>
</form>

        </div>

        <div className="Content2">
            <img
                src={require('../Web_Shuffle2/0080.png')}
                alt="The Stafly app gives user tools to track nutrition, training and wellbeing"
                className="Image"
            />
        </div>
    </div>

    <Footer3></Footer3>
</div>

    );
};

export default SignUp;
